import React from 'react';
import { Button, Stack, Text, VStack, useToast } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import AudioRecorder from '../../components/AudioRecorder';
import { addCatalogueItemByText } from '../../hooks/catalogueItems';
import {
  CatalogueHero,
  CatalogueSectionCard,
  CatalogueShell,
} from './components/catalogueUi';

export default function RecordVoiceAddCatalogueItem() {
  const toast = useToast();
  const navigate = useNavigate();
  const { orgId } = useParams();

  const handleAddVoiceTranscribedProduct = async (text: string) => {
    if (!orgId) {
      return;
    }

    const response = await addCatalogueItemByText(orgId, text);

    if (!response.success) {
      toast({
        title: 'Voice item creation failed',
        description: 'The transcription was captured, but the item could not be created.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    toast({
      title: 'Product generated',
      description: 'Your voice note has been turned into a catalogue item.',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
    navigate(`/organization/${orgId}/catalogue`);
  };

  return (
    <CatalogueShell compact>
      <CatalogueHero
        eyebrow="AI entry"
        title="Speak the product details and let the catalogue catch up"
        description="Use voice input when typing is slower. This is especially useful on mobile when you want to capture items quickly from the field."
      />

      <Stack spacing={6}>
        <CatalogueSectionCard
          title="Voice capture"
          description="Record a concise description of the item. Mention the name, notable features, and price if you know it."
        >
          <VStack spacing={5} py={{ base: 4, md: 8 }}>
            <AudioRecorder
              isCatalogue={true}
              onSaveNote={handleAddVoiceTranscribedProduct}
            />
            <Text fontSize="sm" color="gray.500" textAlign="center" maxW="md">
              For better results, speak clearly and keep the product details structured.
            </Text>
          </VStack>
        </CatalogueSectionCard>
        <Button borderRadius="16px" variant="ghost" onClick={() => navigate(-1)}>
          Cancel
        </Button>
      </Stack>
    </CatalogueShell>
  );
}
